export const FILTER_IDS = {
  LEADER: 'leader',
  LAST: 'last',
  CORRECT: 'correct',
  WRONG: 'wrong',
  NEUTRAL: 'neutral',
};

const FOREHEAD_LANDMARK = 10;
const NOSE_TIP_LANDMARK = 1;

function drawBorder(ctx, color, w, h, thickness = 14) {
  ctx.save();
  ctx.lineWidth = thickness;
  ctx.strokeStyle = color;
  ctx.strokeRect(thickness / 2, thickness / 2, w - thickness, h - thickness);
  ctx.restore();
}

function drawEmojiAt(ctx, emoji, x, y, sizePx) {
  ctx.save();
  ctx.font = `${sizePx}px "Apple Color Emoji", "Segoe UI Emoji", "Noto Color Emoji", serif`;
  ctx.textAlign = 'center';
  ctx.textBaseline = 'middle';
  ctx.fillText(emoji, x, y);
  ctx.restore();
}

function drawTint(ctx, color, w, h) {
  ctx.save();
  ctx.globalCompositeOperation = 'multiply';
  ctx.fillStyle = color;
  ctx.fillRect(0, 0, w, h);
  ctx.restore();
}

export function renderFilter(ctx, landmarks, filterId, w, h) {
  const forehead = landmarks?.[FOREHEAD_LANDMARK];
  const nose = landmarks?.[NOSE_TIP_LANDMARK];
  const crownSize = w * 0.22;

  switch (filterId) {
    case FILTER_IDS.LEADER:
      drawBorder(ctx, '#f4c430', w, h);
      if (forehead) {
        drawEmojiAt(ctx, '👑', forehead.x * w, forehead.y * h - crownSize * 0.55, crownSize);
      }
      break;
    case FILTER_IDS.LAST:
      drawBorder(ctx, '#ff7da6', w, h);
      if (nose) {
        drawEmojiAt(ctx, '🤡', nose.x * w, nose.y * h, w * 0.18);
      }
      break;
    case FILTER_IDS.CORRECT:
      drawBorder(ctx, '#1ec773', w, h, 18);
      if (forehead) {
        drawEmojiAt(ctx, '✅', forehead.x * w, forehead.y * h - crownSize * 0.55, crownSize * 0.8);
      }
      break;
    case FILTER_IDS.WRONG:
      drawBorder(ctx, '#e8443f', w, h, 18);
      drawTint(ctx, 'rgba(232, 68, 63, 0.18)', w, h);
      break;
    case FILTER_IDS.NEUTRAL:
    default:
      break;
  }
}
